var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecruitRegiments2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 58,
    viewBox: "0 0 112 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_22765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83 3C97.3594 3 109 14.6407 109 29C109 43.3594 97.3594 55 83 55C68.6406 55 57 43.3594 57 29C57 14.6407 68.6406 3 83 3Z",
    stroke: "#1A1A18",
    strokeWidth: 2.6664,
    strokeMiterlimit: 22.9256,
    strokeDasharray: "13.33 13.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7432 36.9739L83.9913 38.4619L83.3752 40.5259C80.1271 40.3339 76.5192 40.2301 72.5673 40.2301C67.9351 40.2301 64.3351 40.3978 61.7752 40.718L61.4392 37.982C61.9831 37.982 62.3833 38.014 62.6313 38.0779C62.9514 38.014 63.3834 37.982 63.9352 37.982C65.3752 37.8301 66.7192 37.318 67.9593 36.454C69.2073 35.59 70.2792 34.518 71.1991 33.2379C72.1111 31.958 72.8152 30.6221 73.3111 29.2381C73.8073 27.8461 74.0553 26.6059 74.0553 25.5019C74.0553 23.998 73.6951 22.7101 72.9672 21.614C72.2472 20.5262 71.2312 19.982 69.9273 19.982C68.5912 20.078 67.5193 20.6142 66.7113 21.59C65.9032 22.5739 65.4871 23.9101 65.4633 25.5979C65.4955 25.8542 65.5113 26.2382 65.5113 26.742H64.1193C64.1193 23.8782 64.7353 21.5101 65.967 19.6459C67.1913 17.7822 69.0792 16.8061 71.6073 16.718C72.7272 16.718 73.7352 16.9901 74.6151 17.5261C75.4873 18.0619 76.1832 18.822 76.6869 19.7899C77.1912 20.7662 77.4633 21.8702 77.5113 23.1019C77.5113 24.518 77.2872 25.8379 76.8472 27.062C76.4073 28.2939 75.8151 29.4459 75.0792 30.534C74.3433 31.63 73.4952 32.7178 72.5272 33.8059C71.5672 34.8941 70.6393 35.95 69.7432 36.9739Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1211 17L27.6815 20.5786L34.2424 24.1569L27.6814 28.2358L21.1814 31.7358L14.5605 27.7358L8 24L14.5605 20.5786L21.1211 17Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.54036 38.6996L8.36064 31.468L8.1814 24.2358L14.6814 27.7358L21.1812 31.7358V38.7358V46.2358L14.8609 42.4677L8.54036 38.6996Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1814 31.7358L27.8609 28.0039L34.1814 24.2358L34.0018 31.4681L33.8224 38.7001L27.5019 42.4677L21.1814 46.2358V39.2358V31.7358Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0607 32.0607C63.6464 31.4749 63.6464 30.5251 63.0607 29.9393L53.5147 20.3934C52.9289 19.8076 51.9792 19.8076 51.3934 20.3934C50.8076 20.9792 50.8076 21.9289 51.3934 22.5147L59.8787 31L51.3934 39.4853C50.8076 40.0711 50.8076 41.0208 51.3934 41.6066C51.9792 42.1924 52.9289 42.1924 53.5147 41.6066L63.0607 32.0607ZM37 32.5H62V29.5H37V32.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1211 14L101.681 17.5786L108.242 21.1569L101.681 25.2358L95.1814 28.7358L88.5605 24.7358L82 21L88.5605 17.5786L95.1211 14Z",
    fill: "#D9DADA",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5404 35.6996L82.3606 28.468L82.1814 21.2358L88.6814 24.7358L95.1812 28.7358V35.7358V43.2358L88.8609 39.4677L82.5404 35.6996Z",
    fill: "#D9DADA",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1814 28.7358L101.861 25.0039L108.181 21.2358L108.002 28.4681L107.822 35.7001L101.502 39.4677L95.1814 43.2358V36.2358V28.7358Z",
    fill: "#D9DADA",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_22765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1122.52,
    height: 1587.4,
    fill: "white",
    transform: "translate(-366 -330)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitRegiments2);
export default __webpack_public_path__ + "static/media/recruit_regiments2.7d523215c3b007bffa848844fb73f89e.svg";
export { ForwardRef as ReactComponent };